export default "__VITE_ASSET__CY7uzFm8__";